import { useMediaQuery } from 'react-responsive'

export const useDesktopMediaQuery = () => useMediaQuery({ query: '(min-width: 931px)' })

export const useTabletAndBelowMediaQuery = () => useMediaQuery({ query: '(max-width: 930px)' })

export function DesktopMode({ children }) {
  const isDesktop = useDesktopMediaQuery()

  return isDesktop ? children : null
}

export function MobileMode({ children }) {
  const isTabletAndBelow = useTabletAndBelowMediaQuery()

  return isTabletAndBelow ? children : null
}
